module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_dicot_stem_4-0e049ba0dda33412f31a0d3f7fc94dc6.jpg";